/* @flow */
import UserSchools from './UserSchools';

export default UserSchools;
